import { HeaderWrapper, ReducedMenu, MenuWrapper, ListWrapper } from "./styles";
import {
    HOME_ROUTE,
    HOST_PROFILE_ROUTE,
    STUDENT_PROFILE_ROUTE
} from "../../utils/constants";
import { Logo } from "../Icons/Logo";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { StyledButton, } from "components/generic";
import { hostRoutes, publicRoutes, studentRoutes } from "../../routes";
import { ConteinerPopup, Item, ItemUser } from "../Menu/styles";
import { PopupMenu } from "../PopupMenu";
import { hostMenuRoutes, studentMenuRoutes } from "../Menu";
import { useContextHospi } from "../../context/ContextHospi";
import useSizeWindow from "../../utils/hooks/useWindowSize";
import { ProfileBurger } from "../MobileMenu/ProfileMenu/styles";
import { PersonIcon } from "./styles";
import TabletMenu from "../MobileMenu/TabletMenu";
import ProfileMenu from "../MobileMenu/ProfileMenu";
import { Auth } from "aws-amplify";
import Banner from "components/Banner";
import LangBubble from "../LangBubble";

export const Header = () => {
    const navigate = useNavigate();
    const { userStatus, setUser, getNameUser, userProfile, changeUser, unreadConversations } =
        useContextHospi();

    const { t, i18n } = useTranslation('header');
    const device = useSizeWindow();
    const [leftMenuOpen, setLeftMenuOpen] = useState<boolean>(false)
    const [rightMenuOpen, setRightMenuOpen] = useState<boolean>(false)
    const [registerQueryKey, setRegisterQueryKey] = useState<'h' | 's' | ''>('')

    const location = useLocation();

    useLayoutEffect(() => {
        document.documentElement.scrollTo(0, 0);
        setRegisterQueryKey(location.pathname.includes('/hospita') ? 'h' : location.pathname.includes('/students') ? 's' : '')
    }, [location.pathname]);

    useEffect(() => {
        if (!['header-tablet', 'tablet', 'mobile'].includes(device)) {
            setLeftMenuOpen(false)
            setRightMenuOpen(false)
        }
    }, [device, leftMenuOpen])

    return (
        <HeaderWrapper shadow={true}>
            {/* <Banner
                button={`${t("banner.button")} `}
                text={`${t("banner.text")} `}
                href="https://www.eventbrite.nl/e/tickets-hospi-housing-webinar-verhuur-tijdelijk-een-kamer-in-huis-405115741087?utm_campaign=post_publish&utm_medium=email&utm_source=eventbrite&utm_content=shortLinkNewEmail"
            /> */}
            <div>
                <MenuWrapper>
                    <ProfileMenu open={rightMenuOpen} setOpen={setRightMenuOpen} />
                </MenuWrapper>
                <TabletMenu open={leftMenuOpen} setOpen={setLeftMenuOpen} />
                {
                    !['header-tablet', 'tablet', 'mobile'].includes(device) ? (
                        <nav>
                            <NavLink to={`/${i18n.language}/`} key={HOME_ROUTE}>
                                <Logo />
                            </NavLink>
                            <ListWrapper>
                                {publicRoutes.filter(({ keyLocalize }) => keyLocalize !== 'contact').map((item) => (

                                    <li key={item.path}>
                                        <NavLink
                                            to={`/${i18n.language}${item.path.slice(5)}`}>{t(`menu.${item.keyLocalize}`)}</NavLink>
                                    </li>
                                ))}
                            </ListWrapper>
                            <div>
                                <LangBubble />
                                {userStatus !== undefined ? (
                                    <Item>
                                        <PopupMenu title={`${t("menu.login")} `} top="28px">
                                            <ConteinerPopup>
                                                <ItemUser>
                                                    <p>{t(`subMenu.signedIn`)}</p>
                                                    <p>{getNameUser}</p>
                                                </ItemUser>
                                                <hr />
                                                {userStatus === "student" &&
                                                    userProfile &&
                                                    studentRoutes
                                                        .filter((item) => studentMenuRoutes.includes(item.path))
                                                        .map((item) => (
                                                            <Item key={item.path} popup>
                                                                <NavLink to={`/${i18n.language}${item.path.slice(5)}`}>
                                                                    <span style={{ position: 'relative' }}>
                                                                        {t(`subMenu.${item.keyLocalize}`)}
                                                                        {
                                                                            (item.keyLocalize === 'chats' && unreadConversations.length) ? <div style={{ position: 'absolute', top: 'calc(50% - 2.5px)', right: '-10px', width: 5, height: 5, borderRadius: '50%', background: '#032565' }} /> : ''
                                                                        }
                                                                    </span>
                                                                </NavLink>
                                                            </Item>
                                                        ))}
                                                {userStatus === "host" &&
                                                    userProfile &&
                                                    hostRoutes
                                                        .filter((item) => hostMenuRoutes.includes(item.path))
                                                        .map((item) => (
                                                            <Item key={item.path} popup>
                                                                <NavLink to={`/${i18n.language}${item.path.slice(5)}`}>
                                                                    <span style={{ position: 'relative' }}>
                                                                        {t(`subMenu.${item.keyLocalize}`)}
                                                                        {
                                                                            (item.keyLocalize === 'chats' && unreadConversations.length) ? <div style={{ position: 'absolute', top: 'calc(50% - 2.5px)', right: '-10px', width: 5, height: 5, borderRadius: '50%', background: '#032565' }} /> : ''
                                                                        }
                                                                    </span>
                                                                </NavLink>
                                                            </Item>
                                                        ))}
                                                {["student", "host"].includes(userStatus) && !userProfile && (
                                                    <Item popup>
                                                        <NavLink
                                                            to={`${userStatus === "host"
                                                                ? `/${i18n.language}${HOST_PROFILE_ROUTE.slice(5)}`
                                                                : `/${i18n.language}${STUDENT_PROFILE_ROUTE.slice(5)}`
                                                                }`}
                                                        >
                                                            {t(`subMenu.profile`)}
                                                        </NavLink>
                                                    </Item>
                                                )}
                                                <hr />
                                                <Item
                                                    className="logout"
                                                    popup
                                                    onClick={() => {
                                                        Auth.signOut({ global: true }).finally(() => {
                                                            setUser(undefined)
                                                            changeUser(undefined)
                                                            navigate(`/${i18n.language}/`)
                                                        })
                                                    }}
                                                >
                                                    {t('subMenu.signOut')}
                                                </Item>
                                            </ConteinerPopup>
                                        </PopupMenu>
                                    </Item>
                                ) : <div>
                                    <StyledButton p='9px 17px' outline onClick={() => navigate(`/${i18n.language}/login${registerQueryKey ? `?m=${registerQueryKey}` : ''}`)}>
                                        {t('menu.signIn')}
                                    </StyledButton>
                                    <StyledButton p='9px 17px' onClick={() => navigate(`/${i18n.language}/register${registerQueryKey ? `?m=${registerQueryKey}` : ''}`)}>
                                        {t('menu.signUp')}
                                    </StyledButton>
                                </div>}

                            </div>
                        </nav>
                    ) : (
                        <ReducedMenu>
                            <ProfileBurger
                                rightMenuOpen={rightMenuOpen}
                                open={leftMenuOpen} setOpen={() => {
                                    setLeftMenuOpen(!leftMenuOpen)
                                    setRightMenuOpen(false)
                                }} />
                            <NavLink to={`/${i18n.language}/`} key={HOME_ROUTE}>
                                <Logo />
                            </NavLink>
                            <PersonIcon
                                style={{ zIndex: leftMenuOpen ? 10 : 30 }}
                                size="2.2em"
                                onClick={() => {
                                    setLeftMenuOpen(false)
                                    setRightMenuOpen(!rightMenuOpen)
                                }}
                            />
                        </ReducedMenu>
                    )
                }
            </div>
        </HeaderWrapper>
    )
}
